// Module
var code = `<div class="compliance-profile-config-section">
  <ng-form name="\$ctrl.form">
    <div class="compliance-profile-config-section__column">
      <form-section form-title="'Force profile update'">
        <form-section-field field-title="'Force customer profile update for low risk customers every'">
          <glue-container class="compliance-profile-config-section__glue" append="'months'">
            <input
              type="number"
              ng-model="\$ctrl.complianceConfig.lowRiskMonthSchedule"
              min="0"
              max="1200" />
          </glue-container>
        </form-section-field>
        <form-section-field field-title="'Force customer profile update for normal risk customers every'">
          <glue-container class="compliance-profile-config-section__glue" append="'months'">
            <input
              type="number"
              ng-model="\$ctrl.complianceConfig.normalRiskMonthSchedule"
              min="0"
              max="1200" />
          </glue-container>
        </form-section-field>
        <form-section-field field-title="'Force customer profile update for high risk customers every'">
          <glue-container class="compliance-profile-config-section__glue" append="'months'">
            <input
              type="number"
              ng-model="\$ctrl.complianceConfig.highRiskMonthSchedule"
              min="0"
              max="1200" />
          </glue-container>
        </form-section-field>
        <div class="alert">
          <strong>Info: Use 0 to disable forced update</strong>
        </div>
      </form-section>
    </div>
  </ng-form>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/compliance-config-profile-section.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;